import { createElement, memo, useState, useCallback, useRef } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import './index.scss';
function LetterIndex(props) {
    const { letters, onLetterSelect } = props;
    const [activeL, setActiveL] = useState(null);
    const [activeIndex, setActiveIndex] = useState(0);
    const timerRef = useRef(null);
    const handleLetterClick = useCallback((letter, index) => {
        setActiveL(letter);
        setActiveIndex(index);
        onLetterSelect(letter);
        clearTimeout(timerRef.current);
        timerRef.current = setTimeout(() => setActiveL(null), 800);
    }, [onLetterSelect]);
    // bubble 中心对齐点击的字母 item 中心
    //   const bubbleTop = rpx2px(activeIndex * ITEM_HEIGHT_RPX + ITEM_HEIGHT_RPX / 2 - BUBBLE_HEIGHT_RPX / 2);
    return <View className="cfe-letter-index-wrap">
      <View className="cfe-letter-index-list">
        {letters.map((letter, index) => <View key={letter} className={activeL === letter ? 'cfe-letter-item cfe-letter-item-active' : 'cfe-letter-item'} onClick={() => handleLetterClick(letter, index)}>
            <Text className={activeL === letter ? 'cfe-letter-text cfe-letter-text-active' : 'cfe-letter-text'}>
              {letter}
            </Text>
          </View>)}
      </View>

      
    </View>;
}
export default memo(LetterIndex);
